import { createPlatformLocaleSwitch } from "@airange/ui/platform-locale-switch";
import { redblueAdminLocaleController } from "../lib/locale";

export const LocaleSwitch = createPlatformLocaleSwitch({
  controller: redblueAdminLocaleController,
});
